import { InputDataList } from "../../../../components/modal/FormModal";
import { PostVehicleDto } from "../../../../../network/control/Vehicle";
import { TimePickerInput } from "../../../../components/input/TimePicker";
import { Schema } from "rsuite";
import { isNotBlank } from "../../../../../util/validation";
import { PostVisitControlDto } from "../../../../../network/control/Visit";

export const NewVisitInputSchema = Schema.Model({
  entry: Schema.Types.NumberType().isRequired(
    "Es necesario colocar la hora de ingreso."
  ),
  name: Schema.Types.StringType()
    .isRequired("Es necesario completar este campo.")
    .addRule(isNotBlank(3), "Debe contener al menos 3 caracteres."),
  lastname: Schema.Types.StringType()
    .isRequired("Es necesario completar este campo.")
    .addRule(isNotBlank(3), "Debe contener al menos 3 caracteres."),
  dni: Schema.Types.StringType().isRequired(
    "Es necesario completar este campo."
  ),
});

export const EditVisitInputSchema = Schema.Model({
  departure: Schema.Types.NumberType(),
  observation: Schema.Types.StringType(),
});

export const NewVisitInputList: InputDataList<PostVisitControlDto> = [
  {
    name: "entry",
    label: "Hora de ingreso",
    type: "custom",
    provide: TimePickerInput("entry"),

    defaultValue: undefined,
  },
  {
    name: "departure",
    label: "Hora de salida",
    type: "custom",
    provide: TimePickerInput("departure"),
    defaultValue: undefined,
  },
  {
    name: "name",
    label: "Nombre",
    type: "text",
    placeholder: "Nombre",
    defaultValue: undefined,
  },
  {
    name: "lastname",
    label: "Apellido",
    type: "text",
    placeholder: "Nombre",
    defaultValue: undefined,
  },
  {
    name: "dni",
    label: "DNI",
    type: "text",
    placeholder: "DNI",
    defaultValue: undefined,
  },

  {
    name: "phoneNumber",
    label: "Teléfono",
    type: "text",
    placeholder: "Número de Teléfono",
    defaultValue: undefined,
  },
  {
    name: "subject",
    label: "Motivo de Visita",
    type: "textarea",
    placeholder: "Motivo de Visita",
    defaultValue: undefined,
  },
  {
    name: "observation",
    label: "Observacion",
    type: "textarea",
    placeholder: "Observacion",
    defaultValue: undefined,
  },
  {
    name: "derivation",
    label: "Derivacion",
    type: "text",
    placeholder: "Derivacion",
    defaultValue: undefined,
  },
];

export const EditVehicleInputList: InputDataList<PostVehicleDto> = [
  {
    name: "departure",
    label: "Hora de salida",
    type: "custom",
    provide: TimePickerInput("departure"),
    defaultValue: undefined,
  },
  {
    name: "observation",
    label: "Observacion",
    type: "textarea",
    placeholder: "Observacion",
    defaultValue: undefined,
  },
];
